import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageMenu from '../../components/PageMenu';

const styles = css`
`;

function MenuVideoCategories({ page, ...props }) {
  const categoryLinks = _.get(page, 'video_galleries', []).map(g => ({
    name: 'video-gallery-filtered',
    params: { gallery: _.get(g, 'gallery_title') },
    title: _.get(g, 'gallery_title'),
  }));

  return (
    <PageMenu
      {...props}
      className={styles}
      title="Gallery Menu"
      items={[
        {
          name: 'video-gallery',
          title: 'All Videos',
        },
      ].concat(categoryLinks)}
    />
  );
}

MenuVideoCategories.propTypes = {
  page: PropTypes.object.isRequired,
};

export default MenuVideoCategories;



// WEBPACK FOOTER //
// ./src/pages/VideoGallery/MenuVideoCategories.js